import { StepAction } from './stepAction';

export class RefreshStepAction extends StepAction {
    override async execute() {
        try {
            await this.driver.reloadTab();
            return { success: true };
        } catch (error) {
            return { success: false, reason: error.message };
        }
    }
}
